import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  className = '',
  label,
  error,
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-153">
      {label && <label htmlFor={inputId} className="mb-2 block text-sm font-medium text-gray-700" data-id="element-154">
          {label}
        </label>}
      <input id={inputId} className={`flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#8BA888] focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-155" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-156">{error}</p>}
    </div>;
}